import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import { events } from "../../utils/events";

import styles from "./cite.css";

@customElement("bp-cite")
export class Cite extends LitElement {
  static styles = styles;

  @property()
  href?: string;

  handleClick(e: MouseEvent) {
    if (globalThis.window.BibleProjectApp) e.preventDefault();

    if (this.href) events.requestLinkOpen(this.href);
  }

  render() {
    const children = this.href
      ? html`
          <a href="${this.href}" target="_blank" @click="${this.handleClick}">
            <slot></slot>
          </a>
        `
      : html`<slot></slot>`;

    return html`<cite>${children}</cite>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-cite": Cite;
  }
}
